import { ISagaModule } from 'redux-dynamic-modules-saga';
import { reduxKey } from '../constants';
import reducers from './reducers';
import saga from './sagas';
import { reduxInitialized } from './actions/initialization';

export function getDamzModule(): ISagaModule<any> {
  return {
    id: 'damzModule',
    reducerMap: {
      [reduxKey as string]: reducers,
    },
    initialActions: [reduxInitialized()],
    sagas: [saga],
    retained: true,
  };
}
